interface IBuildRedirectToWhatsappUrl {
  countryNumber: number;
  phoneNumber: string;
}

/**
 * Build a WhatsApp URL for redirecting users to a chat with the specified
 * phone number.
 *
 * @param {IBuildRedirectToWhatsappUrl} params - The parameters for building the URL.
 * @param {number} params.countryNumber - The country code to prepend to the phone number.
 * @param {string} params.phoneNumber - The phone number to include in the URL.
 *
 * @returns {string} The constructed WhatsApp URL for redirection.
 *
 * @example
 * buildRedirectToWhatsappUrl({ phoneNumber: '08123456789' }); // returns 'https://wa.me/8123456789'
 */
export function buildRedirectToWhatsappUrl({
  countryNumber,
  phoneNumber,
}: IBuildRedirectToWhatsappUrl): string {
  const sanitizedPhoneNumber = phoneNumber
    .replace(/\D/g, '')
    .replace(/^0+/, '');
  return `https://wa.me/${countryNumber}${sanitizedPhoneNumber}`;
}
